import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js";

// Connects to data-controller="home"
export default class extends Controller {
  static targets = ["carousel"]

  connect() {
    this.createSlider()
  }

  createSlider() {
    if (this.hasCarouselTarget) {
      $(this.carouselTarget).slick({
        dots: false,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        focusOnSelect: false,
      });
    }
  }
}
